// frontend/src/components/Register.js
import { useState } from 'react';
import {Eye, EyeOff, Mail, Lock, User} from "lucide-react";
import logo from './../logo.png';

const Register = ({setToken, onBackToLogin}) => {
    // const [useremail, setUseremail] = useState('');
    // const [userpass, setUserpass] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [formData, setFormData] = useState({
        username:'',
        useremail: '', 
        userpass: '',
        userconfirmpass: ''
    });
    const [errors, setErrors] = useState({
        username:'', 
        useremail: '', 
        userpass: '', 
        userconfirmpass: ''
    });
    const validateEmail = (useremail) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(useremail));
    };
    const handleInputChange = (field, value) => {
        setFormData({...formData, [field]: value});
        if(errors[field]) setErrors({...errors, [field]:""});
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        let hasErrors = false;
        const newErrors = {
            username:'',
            useremail: '',
            userpass: '',
            userconfirmpass: ''
        };
        if(!formData.username){
            newErrors.username = 'O nome de usuário é obrigatório';
            hasErrors = true;
        }
        if(!formData.useremail){
            newErrors.useremail = 'O e-mail é obrigatório';
            hasErrors = true;
        } else if (!validateEmail(formData.useremail)) {
            newErrors.useremail = 'Por favor, insira um e-mail válido';
            hasErrors = true;
        }
        if(!formData.userpass){
            newErrors.userpass = 'A senha é obrigatória';
            hasErrors = true;
        } else if (formData.userpass !== formData.userconfirmpass) {
            newErrors.userpass = 'As senhas devem ser iguas';
            hasErrors = true;
        }
        setErrors(newErrors);
        if(!hasErrors){
            const response = await fetch('/api/auth/register', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                // body: JSON.stringify({userEmail, userPass})
                body: JSON.stringify(formData)
            });
            const data = await response.json();
            setToken(data.access_token);
        }
    };

    return (
        <div className="min-vh-100 d-flex align-items-center justify-content-center p-4">
            <div className="w-100" style={{maxWidth:'480px'}}>
                <img src={logo} className="row mx-auto m-5" alt="Logo" style={{height: '150px'}}/>
                {/* Sign Up Card */}
                <div className="custom-card p-4 p-md-5">
                    <h2 className="h3 fw-bold mb-2">Criar conta</h2>
                    <form onSubmit={handleSubmit}>
                        {/* Name Input */}
                        <div className="mb-3">
                            <label htmlFor="username" className="form-label">
                                Nome
                            </label>
                            <div className="input-group">
                                <span className="input-group-text bg-transparent border-end-0" style={{ borderColor: 'var(--color-border)', color: 'var(--color-text-secondary)' }}>
                                    <User size={18} />
                                </span>
                                <input
                                    type="text"
                                    className={`form-control bg-transparent border-start-0 ${errors.username ? 'border-danger' : ''}`}
                                    id="username"
                                    placeholder="Nome"
                                    value={formData.username}
                                    onChange={(e) => handleInputChange("username", e.target.value)}
                                    style={{ 
                                        borderColor: errors.username ? 'var(--color-danger)' : 'var(--color-border)',
                                        color: 'var(--color-text-primary)',
                                    }}
                                />
                            </div>
                            {errors.username && (
                                <small className="text-danger-custom d-block mt-1">
                                    {errors.username}
                                </small>
                            )}
                        </div>

                        {/* Email Input */}
                        <div className="mb-3">
                            <label htmlFor="useremail" className="form-label">
                                E-mail
                            </label>
                            <div className="input-group">
                                <span className="input-group-text bg-transparent border-end-0" style={{ borderColor: 'var(--color-border)', color: 'var(--color-text-secondary)' }}>
                                    <Mail size={18} />
                                </span>
                                <input
                                    type="email"
                                    className={`form-control bg-transparent border-start-0 ${errors.useremail ? 'border-danger' : ''}`}
                                    id="useremail"
                                    placeholder="E-mail"
                                    value={formData.useremail}
                                    onChange={(e) => handleInputChange("useremail", e.target.value)}
                                    style={{ 
                                        borderColor: errors.useremail ? 'var(--color-danger)' : 'var(--color-border)',
                                        color: 'var(--color-text-primary)',
                                    }}
                                />
                            </div>
                            {errors.useremail && (
                                <small className="text-danger-custom d-block mt-1">
                                    {errors.useremail}
                                </small>
                            )}
                        </div>

                        {/* Password Input */}
                        <div className="mb-3">
                            <label htmlFor="userpass" className="form-label">
                                Senha
                            </label>
                            <div className="input-group">
                                <span className="input-group-text bg-transparent border-end-0" style={{ borderColor: 'var(--color-border)', color: 'var(--color-text-secondary)' }}>
                                    <Lock size={18} />
                                </span>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className={`form-control bg-transparent border-start-0 border-end-0 ${errors.userpass ? 'border-danger' : ''}`}
                                    id="userpass"
                                    placeholder="Senha"
                                    value={formData.userpass}
                                    onChange={(e) => handleInputChange("userpass", e.target.value)}
                                    style={{ 
                                        borderColor: errors.userpass ? 'var(--color-danger)' : 'var(--color-border)',
                                        color: 'var(--color-text-primary)',
                                    }}
                                />
                                <button
                                    type="button"
                                    className="input-group-text bg-transparent border-start-0"
                                    style={{ borderColor: 'var(--color-border)', color: 'var(--color-text-secondary)', cursor: 'pointer' }}
                                    onClick={() => setShowPassword(!showPassword)}
                                    aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                                >
                                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                </button>
                            </div>
                            {errors.userpass && (
                                <small className="text-danger-custom d-block mt-1">
                                    {errors.userpass}
                                </small>
                            )}
                        </div>

                        {/* Confirm Password Input */}
                        <div className="mb-4">
                            <label htmlFor="userconfirmpass" className="form-label">
                                Confirmar Senha
                            </label>
                        <div className="input-group">
                            <span className="input-group-text bg-transparent border-end-0" style={{ borderColor: 'var(--color-border)', color: 'var(--color-text-secondary)' }}>
                                <Lock size={18} />
                            </span>
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                className={`form-control bg-transparent border-start-0 border-end-0 ${errors.userconfirmpass ? 'border-danger' : ''}`}
                                id="userconfirmpass"
                                placeholder="Confirmar senha"
                                value={formData.userconfirmpass}
                                onChange={(e) => handleInputChange("userconfirmpass", e.target.value)}
                                style={{ 
                                    borderColor: errors.userconfirmpass ? 'var(--color-danger)' : 'var(--color-border)',
                                    color: 'var(--color-text-primary)',
                                }}
                            />
                            <button
                                type="button"
                                className="input-group-text bg-transparent border-start-0"
                                style={{ borderColor: 'var(--color-border)', color: 'var(--color-text-secondary)', cursor: 'pointer' }}
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                aria-label={showConfirmPassword ? "Ocultar confirmação de senha" : "Mostrar confirmação de senha"}
                            >
                                {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                            </button>
                        </div>
                        {errors.userconfirmpass && (
                            <small className="text-danger-custom d-block mt-1">
                                {errors.userconfirmpass}
                            </small>
                        )}
                        </div>

                        {/* Sign Up Button */}
                        <button
                            type="submit"
                            className="btn btn-primary-custom w-100 py-2 mb-3"
                        >
                            Criar conta
                        </button>

                        {/* Divider */}
                        <div className="position-relative my-4">
                            <div className="position-absolute w-100 top-50 start-0" style={{ borderTop: '1px solid var(--color-border)' }}></div>
                        </div>
                    </form>

                    {/* Login Link */}
                    <div className="text-center mt-4 pt-3" style={{ borderTop: '1px solid var(--color-border)' }}>
                        <span className="text-muted-custom">Já possui uma conta? </span>
                        <button
                            type="button"
                            className="btn btn-link p-0 text-primary-custom text-decoration-none"
                            onClick={onBackToLogin}
                        >
                            Entrar
                        </button>
                    </div>
                </div>

                {/* Footer */}
                <div className="text-center mt-4">
                    <p className="text-muted-custom small mb-0">
                        Termos e condições
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Register;